import React, {useEffect, useState} from 'react';

const Tab = (props) => {
  const [active, setActive] = useState(props.activeTab);
  const [disabled, setDisabled] = useState(props.disabledTab);

  useEffect(() => {
    setActive(props.activeTab);
    setDisabled(props.disabledTab);
  }, [props.activeTab, props.disabledTab]);
  
  const handleClick = (e) => {
    const elem = e.currentTarget,
      tab = elem.closest(".tab"),
      key = parseInt(elem.getAttribute('data-key')),
      currContent = tab.querySelector('.tab__content.is-active'),
      thisContent = tab.querySelector('.tab__content[data-key="' + key + '"]');

    currContent.classList.remove('is-active');
    thisContent.classList.add('is-active');
    setActive(key);
    renderTabs();
  }

  const renderTabs = () => {
    const titles = props.options.split('|'),
      html = [];

    titles.forEach((elem, i) => {
      let classNameResult = (active == i) ? ' is-active' : '';
      classNameResult = classNameResult + ((disabled == i) ? ' is-disabled' : '');
      html.push(<div className={"tab__option" + classNameResult} onClick={handleClick} key={i} data-key={i}>{elem}</div>)
    }); 
    return html;
  }
  
  return (     
    <div className={"tab" + (props.className ? ' ' + props.className : '')}>
      <div className="tab__wrapper">
        <div className="tab__options">
          {renderTabs()}
        </div>
      </div>
      
      <div className="tab__contents">
        {props.contents}
      </div>
    </div>
  )
}

export default Tab;